import React from 'react';
import Title from '../../components/Title';
import Subtitle from '../../components/Subtitle';
import FeatureList from '../../components/FeatureList';
import {
  MdOutlineCardGiftcard,
  MdOutlineLocalPlay,
  MdOutlineCelebration,
  MdOutlineTheaterComedy,
  MdOutlineVolunteerActivism,
  MdOutlineTableBar,
} from 'react-icons/md';
import hero2Desktop from './assets/hero2-desktop.png';

const features = [
  {
    icon: MdOutlineCardGiftcard,
    title: 'Participe de promoções do shopping',
    description: 'Envie notas fiscais de suas compras e concorra a prêmios',
  },
  {
    icon: MdOutlineTableBar,
    title: 'Reserve uma mesa em nossos restaurantes',
    description: 'Ou aproveite para entrar na fila online',
  },
  {
    icon: MdOutlineLocalPlay,
    title: 'Aproveite vantagens do programa de relacionamento',
    description: 'Ative cupons de desconto e outros benefícios para aproveitar no shopping',
  },
  {
    icon: MdOutlineCelebration,
    title: 'Fique por dentro dos eventos',
    description: 'Acompanhe a programação de atividades para toda a família',
  },
  {
    icon: MdOutlineTheaterComedy,
    title: 'Aproveite cinema ou teatro',
    description: 'Veja o que está em cartaz e garanta seu ingresso',
  },
  {
    icon: MdOutlineVolunteerActivism,
    title: 'Aproveite comodidades',
    description: 'Utilize facilidades oferecidas pelo concierge do shopping',
  },
];

const FeaturesSection = () => (
  <section className="bg-white py-8 md:py-20" id="conheca">
    <div className="max-w-[1300px] w-full px-5 mx-auto">
      <Title className="text-center md:text-center">O Multi é um superapp</Title>
      <Subtitle className="max-w-3xl mx-auto mt-4 text-center md:text-center">
        São benefícios, vantagens e serviços criados para facilitar a sua vida enquanto você curte o melhor do shopping.
      </Subtitle>

      {/* Illustrative image */}
      <div className="flex justify-center mt-12 items-start flex-col lg:flex-row">
        <img
          src={hero2Desktop}
          alt="Usuária utilizando o app Multi"
          className="w-full max-w-[780px] h-auto md:max-w-none lg:max-w-[600px] xl:max-w-[800px]"
        />

        <FeatureList items={features} />
      </div>
    </div>
  </section>
);

export default FeaturesSection;
